import * as React from 'react'
import PageLayout from '@/components/ui/page-layout'
import SubscriptionForm from '@/features/subscriptions/components/SubscriptionForm'

export default function NewSubscriptionPage() {
    const breadcrumbs = [
        { label: 'Subscriptions', href: '/subscriptions' },
        { label: 'New Subscription', href: '/subscriptions/new' },
    ]
    return (
        <PageLayout title='New Subscription' subtitle='Create a new subscription plan' breadcrumbs={breadcrumbs}>
            <SubscriptionForm />
        </PageLayout>
    )
}


